/**
 * Etichetta valuta mostrata in UI.
 * Il backend può ancora usare enum/stringhe "DIOS10" (es. filtri admin, PayPal item_name se richiesto dall'API).
 */
export const CURRENCY_LABEL = 'DIOS';
